export default {
  common: {
    loading: '加载中',
    confirm: '确定',
    cancel: '取消',
    save: '保存',
    back: '返回',
    copy: '复制',
    delete: '删除',
    copySuccess: '复制成功',
    editSuccess: '编辑成功',
    deleteSuccess: '删除成功',
    modifySuccess: '修改成功',
    cannotBeEmpty: '不能为空',
    noContent: '暂无内容',
    noData: '暂无相关数据',
    noMoreData: '没有更多的数据了',
    iKnow: '我已知悉',
    selectService: '选择服务商',
    sendSuccess: '发送成功',
  },
  billHome: {
    recharge: '充值缴费服务',
    coupon: '优惠券',
    rechargeNow: '立即充值',
    cost: '话费',
    flow: '流量',
    rechargeNotice: '充值必看',
    rechargeCost: '充值话费',
    rechargeFlow: '充值流量',
    rechargeAmount: '充值金额',
    rechargePackage: '充值套餐',
    discount: '已优惠',
    confirmTxt: '确认无误',
    confirmTxt1: '我知道了',
    actualPayment: '实付',
    selectCoupon: '选择优惠券',
    useRule: '使用规则',
    availableCoupon: '可用优惠券',
    unavailableCoupon: '不可用优惠券',
    noAvailableCoupon: '暂无可用优惠券',
    selectPhone: '选择手机号',
    pleaseInputPhone: '请输入手机号',
    couponCount: '张可用',
    pleaseInputCorrectPhone: '请输入正确的手机号码',
    pleaseSelectPackage: '请选择充值套餐',
  },
  accountManage: {
    title: '账号管理',
    edit: '编辑',
    deleteConfirm: '确认删除',
  },
  rechargeDetail: {
    title: '缴费详情',
    continuePay: '继续支付',
  },
  feesExpense: {
    title: '缴费记录',
    recharge: '手机费',
    electricity: '电费',
    internet: '网费',
    water: '水费',
    photo: '拍照',
    complete: '完成',
    manage: '管理',
    allSelect: '全选',
    selected: '已选',
    deleteConfirm: '确认删除这',
    deleteRecord: '条缴费记录吗？',
    noDataAction: '暂无数据可操作',
    pleaseSelect: '请先选择要删除的记录',
    feesNotice: '缴费必看',
  },
  formCom: {
    upload: '点击上传',
    saveAccount: '保存或更新已有的账号',
    createOrder: '创建订单',
    rechargeIng: '正在充值',
    rechargeNow: '立即充值',
    serviceProvider: '服务商',
    billImage: '账单图',
    returnSelect: '返回重选',
    electricity: '电费缴纳',
    internet: '网费缴纳',
    water: '水费缴纳',
    photo: '拍照缴费',
    life: '生活缴费',
    uploadFail: '上传失败，请重试',
    pleaseFill: '请填写完整信息',
    submitSuccess: '提交成功，请等待支付',
  },
  langPop: {
    selectLang: '选择语言',
  },
  loginPop: {
    loginOrRegister: '请登录或注册筷子账号',
    confirmLogout: '确定要退出登录吗？',
    toLogin: '去登录',
    logoutSuccess: '退出成功',
  },
  newMe: {
    myOrder: '我的订单',
    coupon: '优惠券',
    accountManage: '账号管理',
    orderCount: '笔订单进行中',
    couponCount: '张',
    account: '账户',
    logout: '退出登录',
  },
  coupons: {
    all: '全部',
    coupon: '优惠券',
    historyCoupon: '历史优惠券',
    use: '去使用',
    validityPeriod: '有效期',
    useRule: '使用规则',
    used: '已使用',
    expired: '已过期',
  },
  accountSeting: {
    title: '设置',
    personalInfo: '个人资料',
    modifyPayPassword: '修改支付密码',
    modifyLoginPassword: '修改登录密码',
    phone: '手机号',
    code: '验证码',
    loginPassword: '登录密码',
    confirmModify: '确认修改',
    noCode: '收不到验证码？',
    passwordPlaceholder: '密码为8~16位数字和字母的组合',
    inputCorrectPhone: '请输入正确的手机号',
    afterGetCode: '后可再次获取',
    getCode: '获取验证码',
    input6DigitPassword: '请输入6位数字密码',
    twoInputPasswordNotConsistent: '两次输入的密码不一致',
    placeholderCode: '请输入验证码',
    confirmPassword: '确认密码',
    password: '密码',
    submit: '提交',
    avatar: '头像',
    userName: '用户名',
    nickName: '昵称',
    modifyPhone: '修改手机号',
    nickNamePlaceholder: '做一个有身份的人',
    sex: '性别',
    male: '男',
    female: '女',
    email: 'Email',
    emailPlaceholder: '设置邮箱方便找回密码',
    pleaseCompletePersonalData: '请完善个人资料，体验更多功能',
    bindNewPhone: '绑定新的手机号',
    oldPhone: '旧手机',
    completeVerification: '完成验证',
    changePayPasswordTitle: '修改支付密码',
    changePasswordTitle: '修改密码',
    oldPhoneTitle: '验证旧手机号',
    editInfoTitle: '编辑个人资料',
    areaCode: '区号',
  },
}
